import {BaseApiTemplateService, Core2Config} from "../../../shared";
import {SquadContainerModel} from "../../../../../../../models/aggregates/alg/cc/squad";
import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";

@Injectable({providedIn: 'root'})
export class SquadService extends BaseApiTemplateService<SquadContainerModel>{
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'squads';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'squads';
    this.httpClient = http;
  }
}
